export type Production = "production";
export type PreProduction = "preproduction";
export type Dev = "dev";
export type QA = "qa";
export type Local = "local";
export type Environment = Production | PreProduction | Dev | QA | Local;

export const environment: Environment = ((): Environment => {
  if (/local.xfinity.com/.test(window.location.hostname)) {
    return "local";
  }
  if (/hsflow-qa.dss-ops.xfinity.com/.test(window.location.hostname)) {
    return "qa";
  }
  if (/www.stg.xfinity.com/.test(window.location.hostname)) {
    return "preproduction";
  }
  return "production";
})();
